/* the order define also the rendering order left -> to -> right */
export const ROUTES = {
  home: '/',
  login: '/login',
  priceCalculator: '/price-calculator',
  marketTrends: '/market-trends',
  myStock: '/my-stock',
  competitorAnalysis: '/competitor-analysis',
} as const;
